<script>
import { Bar } from 'vue-chartjs';

export default {
  name: 'GeneralGraph',
  extends: Bar,
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 255,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    ordersInPeriod: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Quantidade de pedidos',
            backgroundColor: 'rgba(54, 162, 235, 0.8)',
            data: [],
          },
        ],
      },
      /** @type {import("chart.js").ChartOptions} */
      chartOptions: {
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Quantidade de pedidos',
              },
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Período',
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  watch: {
    ordersInPeriod: {
      deep: true,
      handler() {
        this.handleOrdersInPeriod();
        this.renderChart(
          this.chartData,
          this.chartOptions,
          this.width,
          this.height
        );
      },
    },
  },
  mounted() {
    this.handleOrdersInPeriod();
    this.renderChart(
      this.chartData,
      this.chartOptions,
      this.width,
      this.height
    );
  },
  methods: {
    handleOrdersInPeriod() {
      this.chartData.labels = [];
      this.chartData.datasets[0].data = [];

      const { result = [], filterBy } = this.ordersInPeriod;

      const isMonthFilter = filterBy === 'month';

      this.chartOptions.scales.xAxes[0].scaleLabel.labelString = isMonthFilter
        ? 'Meses'
        : 'Dias';

      Object.entries(result).forEach(([key, value]) => {
        if (isMonthFilter) {
          this.createLabelsToMonth(key);
        } else {
          this.createLabelsToDay(key);
        }

        this.chartData.datasets[0].data.push(value);
      });
    },
    createLabelsToMonth(date) {
      const [year, month, day] = date.split('-');

      this.chartData.labels.push(
        new Date(year, month - 1, day).toLocaleString('pt-BR', {
          month: 'long',
        })
      );
    },
    createLabelsToDay(date) {
      const [year, month, day] = date.split('-');

      this.chartData.labels.push(day);
    },
  },
};
</script>